import CallToBook from './CallToBook';
import NextArrow from './NextArrow';
import Notification from './Notification';
import PrevArrow from './PrevArrow';
import ResmarkButton from './ResmarkButton';
import ReviewRating from './ReviewRating';
import ReviewsModal from './ReviewsModal';
import ReturnToFilters from './ReturnToFilters';

export {
    CallToBook,
    NextArrow,
    Notification,
    PrevArrow,
    ResmarkButton,
    ReviewRating,
    ReviewsModal,
    ReturnToFilters
};


// WEBPACK FOOTER //
// ./resources/js/components/Shared/index.js